(() => {
  const gallery = document.querySelector('.product-gallery--desktop')
  const control = document.querySelector('[data-el="gallery-progress"]')
  const desktop = window.matchMedia('(min-width: 901px)')

  if (!gallery || !control) return

  const track = control.querySelector('[data-el="gallery-progress.track"]')
  const thumb = control.querySelector('[data-el="gallery-progress.thumb"]')
  const up = control.querySelector('[data-el="gallery-progress.up"]')
  const down = control.querySelector('[data-el="gallery-progress.down"]')

  let dragging = false
  let dragStartY = 0
  let dragStartScroll = 0

  const maxScroll = () => Math.max(0, gallery.scrollHeight - gallery.clientHeight)

  const update = () => {
    if (!desktop.matches) {
      control.hidden = true
      return
    }

    const max = maxScroll()
    if (max <= 0) {
      control.hidden = true
      return
    }

    control.hidden = false
    const progress = Math.min(1, Math.max(0, gallery.scrollTop / max))
    const travel = Math.max(0, track.clientHeight - thumb.offsetHeight)
    thumb.style.height = ''
    thumb.style.transform = `translateY(${progress * travel}px)`
    up.classList.toggle('is-disabled', gallery.scrollTop <= 0)
    down.classList.toggle('is-disabled', gallery.scrollTop >= max - 1)
  }

  gallery.addEventListener('scroll', update, { passive: true })

  // overscroll-behavior stops native chaining, so page scroll is forwarded manually at the gallery's edges
  gallery.addEventListener('wheel', (event) => {
    if (!desktop.matches || event.ctrlKey || event.deltaY === 0) return

    const atTop = gallery.scrollTop <= 0
    const atBottom = gallery.scrollTop >= maxScroll() - 1
    if ((event.deltaY < 0 && !atTop) || (event.deltaY > 0 && !atBottom)) return

    const unit = event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? window.innerHeight : 1
    event.preventDefault()
    window.scrollBy(0, event.deltaY * unit)
  }, { passive: false })
  window.addEventListener('resize', update)
  desktop.addEventListener('change', update)

  const progressFromClientY = (clientY) => {
    const rect = track.getBoundingClientRect()
    if (rect.height <= 0) return 0
    return Math.min(1, Math.max(0, (clientY - rect.top) / rect.height))
  }

  up.addEventListener('click', () => {
    gallery.scrollBy({ top: -gallery.clientHeight * 0.8, behavior: 'smooth' })
  })

  down.addEventListener('click', () => {
    gallery.scrollBy({ top: gallery.clientHeight * 0.8, behavior: 'smooth' })
  })

  const startDrag = (event) => {
    dragging = true
    event.currentTarget.setPointerCapture?.(event.pointerId)
    gallery.scrollTop = progressFromClientY(event.clientY) * maxScroll()
  }

  thumb.addEventListener('pointerdown', startDrag)
  track.addEventListener('pointerdown', startDrag)

  window.addEventListener('pointermove', (event) => {
    if (!dragging) return
    gallery.scrollTop = progressFromClientY(event.clientY) * maxScroll()
  })

  window.addEventListener('pointerup', () => {
    dragging = false
  })

  if (document.readyState === 'complete') {
    update()
  } else {
    window.addEventListener('load', update)
  }
})()
